import { WidgetType } from "@codemirror/view";

export class CharacterWidget extends WidgetType {
    constructor(content) {
        super();
        this.content = content;
    }

    toDOM() {
        const element = document.createElement("span");
        element.classList.add("ol-cm-character");
        element.textContent = this.content;
        return element;
    }

    eq(widget) {
        return widget.content === this.content;
    }

    updateDOM(element) {
        element.textContent = this.content;
        return true;
    }

    ignoreEvent(event) {
        return event.type !== "mousedown" && event.type !== "mouseup";
    }

    coordsAt(element) {
        return element.getBoundingClientRect();
    }
}

export const COMMAND_SUBSTITUTIONS = new Map([
    ["\\\\", " "],
    ["\\%", "%"],
    ["\\_", "_"],
    ["\\}", "}"],
    ["\\~", "~"],
    ["\\&", "&"],
    ["\\#", "#"],
    ["\\{", "{"],
    ["\\$", "$"],
    ["\\textasciicircum", "^"],
    ["\\textless", "<"],
    ["\\textasciitilde", "~"],
    ["\\textbackslash", "\\"],
    ["\\textbar", "|"],
    ["\\textperiodcentered", "·"],
    ["\\textquestiondown", "¿"],
    ["\\textquotedblleft", "“"],
    ["\\textquotedblright", "”"],
    ["\\textquoteleft", "‘"],
    ["\\textquoteright", "’"],
    ["\\textdagger", "†"],
    ["\\textdaggerdbl", "‡"],
    ["\\textellipsis", "…"],
    ["\\textemdash", "—"],
    ["\\textendash", "–"],
    ["\\textunderscore", "_"],
    ["\\textgreater", ">"],
    ["\\ddag", "‡"],
    ["\\pounds", "£"],
    ["\\copyright", "©"],
    ["\\dots", "…"],
    ["\\S", "§"],
    ["\\dag", "†"],
    ["\\P", "¶"],
    ["\\ae", "æ"],
    ["\\AE", "Æ"],
    ["\\oe", "œ"],
    ["\\OE", "Œ"],
    ["\\ss", "ß"],
    ["\\ldots", "…"],
]);

export function createCharacterCommand(command) {
    const substitution = COMMAND_SUBSTITUTIONS.get(command);
    if (substitution !== undefined) {
        return new CharacterWidget(substitution);
    }
    return undefined;
}

export function hasCharacterSubstitution(command) {
    return COMMAND_SUBSTITUTIONS.has(command);
}
